import { render, staticRenderFns } from "./PromotionOverview.vue?vue&type=template&id=560b6d84"
import script from "./PromotionOverview.vue?vue&type=script&lang=js"
export * from "./PromotionOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports